
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { AlertTriangle, CheckCircle, Info, XCircle } from "lucide-react"
import { cn } from "@/lib/utils"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant = "default", ...props }) {
        let Icon = Info;
        let variantClass = "";
        let toastVariant: "default" | "destructive" | "success" = "default";
        
        // Determine which icon to use based on variant
        if (variant === "destructive") {
          Icon = AlertTriangle;
          variantClass = "text-destructive";
          toastVariant = "destructive";
        } else if (variant === "success") {
          Icon = CheckCircle;
          variantClass = "text-green-500";
          toastVariant = "success";
        } else {
          Icon = Info;
          variantClass = "text-primary";
        }
            
        return (
          <Toast key={id} {...props} variant={toastVariant} className={cn(props.className)}>
            <div className="flex">
              <Icon className={cn("h-5 w-5 mr-3", variantClass)} />
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
